import { getTokenDefinition, } from "@bracket/chainography";
import { wagmiConfig as config, } from "@wagmiconfig";
import { allowance, } from "@bracket/contractor-next/erc20"
import type { TokenIdentifier, } from "@bracket/types";


/**
 * Gets the token allowance for a given token
 * @param {Object} params - The parameters object
 * @param {TokenDefinition} params.token - The token to get the allowance for
 * @returns {Promise<bigint>} The allowance of the token
 * @throws {Error} If the allowance value is invalid
 */
export const getTokenAllowance = async ({
	token,
}: {
	token: TokenIdentifier;
}): Promise<bigint> => {
	const { address, } = getTokenDefinition({ symbol: "BRKTETH", chainId: 1, });
  const tokenDefinition = getTokenDefinition(token);
	return allowance({
		token: tokenDefinition,
		spender: address,
		config,
	});
}
